import { NormalizedKeyboardEventCriteriaKeys, normalizeKeyboardEvent, normalizeKeyboardEventCriteria, } from 'js/file_viewer/keyboard/keyboard_binding';
function keyBy(bindings, getIndex) {
    return bindings.reduce((accumulator, { keyboardEventCriteria, callback }) => {
        const index = getIndex(keyboardEventCriteria);
        accumulator[index] = callback;
        return accumulator;
    }, {});
}
function getIndexForNormalizedCriteria(criteria) {
    return NormalizedKeyboardEventCriteriaKeys.map((key) => `${key}:${criteria[key]}`).join('');
}
/**
 * This function is used to generate an index in the KeyboardBindingsMap.
 * @param event
 */
function getIndexForKeyboardBinding(event, osModifierKey) {
    const criteria = normalizeKeyboardEventCriteria(event, osModifierKey);
    return getIndexForNormalizedCriteria(criteria);
}
/**
 * This is used by the KeyboardProvider to create a simple way to map
 * KeyboardEvents to callbacks.
 * @param keyboardBindings
 */
function generateActiveKeyboardBindings(bindings, osModifierKey) {
    return keyBy(bindings, (binding) => getIndexForKeyboardBinding(binding, osModifierKey));
}
export class KeyboardBindingMap {
    constructor(bindings, osModifierKey) {
        this.bindingDict = {};
        this.bindingDict = generateActiveKeyboardBindings(bindings, osModifierKey);
    }
    getCallbackForEvent(event) {
        const normalizedEvent = normalizeKeyboardEvent(event);
        return this.bindingDict[getIndexForNormalizedCriteria(normalizedEvent)];
    }
}
//# sourceMappingURL=keyboard_binding_map.preenvesnextjs.map
